/* tslint:disable:max-line-length */
import { IRequestEstimate } from '../interfaces/IRequest';

export const getEstimateAttachmentsWithUrl = async (URLGetter: (storageId: string) => Promise<{contentType?: string; url: string } | undefined >, estimate ?: IRequestEstimate) => (
    estimate ? {
        ...estimate,
        ...(estimate.attachments && {
            attachments: await Promise.all(estimate.attachments.map(async ({ id }) => ({ id, ...(await URLGetter(id)) }))),
        }),
    } : undefined);

export default getEstimateAttachmentsWithUrl;
